import React, { useEffect, useState, useCallback } from "react";
import {
  Col,
  Row,
  Card,
  CardBody,
  Button,
  InputGroup,
  Input,
  ButtonGroup,
  Table,
  InputGroupText,
} from "reactstrap";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Triangle } from "react-loader-spinner";
import toast from "react-hot-toast";
import CustomDataTable from "../../../Components/CustomTable/CustomTable";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/themes/material_blue.css";

import {
  formatDate,
  formatDateTimes,
} from "../../../Components/Common/FormatDate";
import Select from "react-select";
import CustomerServices from "../../../services/OrderingServices/CustomerServices";
import CreditLogService from "../../../services/OrderingServices/CreditLogService";
import CreditPayModal from "../component/CreditPayModal";
import NumberWithCommas from "../../../pages/Pages/Starter/NumberWithCommas";
const customStyles = {
  headCells: {
    style: {
      fontSize: "0.92rem",
      fontWeight: 610,
    },
  },
  rows: {
    style: {
      fontSize: "0.9rem",
    },
  },
};

const CustomerPayment = () => {
  const { id } = useParams();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [remarks, setRemarks] = useState();
  const [touched, setTouched] = useState();
  const isInvalid = touched && !remarks?.trim();
  const [isOpen, setIsOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState();
  console.log("🚀 ~ CustoemrPayment ~ selectedItem:", selectedItem);
  const [selectedCustomer, setSelectedCustomer] = useState();
  const navigate = useNavigate();
  const toggleModal = (row) => {
    setIsOpen(!isOpen);
    setSelectedItem(row);
  };
  const today = new Date();
  const todayStr = today.toISOString().split("T")[0];
  const oneMonthAgo = new Date();
  oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1);
  const oneMonthAgoStr = oneMonthAgo.toISOString().split("T")[0];

  const [filters, setFilters] = useState({
    startDate: oneMonthAgoStr,
    endDate: todayStr,
  });

  const [customerList, setCustomerList] = useState([]);
  const fetchCustomers = async () => {
    try {
      setLoading(true);
      const response = await CustomerServices.getCustomerList();

      const transformed = response.map((cust) => ({
        value: cust.id,
        label: `${cust.firstName} ${cust.lastName}`,
        ...cust,
      }));

      setCustomerList(transformed);

      // If we have id from params, select the corresponding customer
      if (id) {
        const selected = transformed.find((cust) => cust.id === parseInt(id));
        if (selected) setSelectedCustomer(selected);
      }

      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log("🚀 ~ error:", error);
    }
  };

  // Fetch customers when debounced filters, current page or page size changes
  useEffect(() => {
    fetchCustomers();
  }, []);
  const fetchCreditLogs = async (customerId, startDate, endDate) => {
    try {
      setLoading(true);
      const response = await CreditLogService.getAllList({
        customerId: customerId || undefined,
        startDate: startDate,
        endDate: endDate,
      });
      setData(response);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log("🚀 ~ error:", error);
    }
  };

  // Fetch credit logs when selectedCustomer or filters change
  useEffect(() => {
    fetchCreditLogs(selectedCustomer?.id, filters.startDate, filters.endDate);
  }, [selectedCustomer]);

  const [filterText, setFilterText] = useState("");

  const handleFilterChange = (e) => {
    setFilterText(e.target.value);
  };

  const filteredData = data.filter((pkg) => {
    // console.log("🚀 ~ filteredPackages ~ pkg:", pkg);

    // Combine name, surname, email, and phone number into a single search context, handling undefined fields
    const searchContext = `${pkg?.orderId || ""}`.toLowerCase();

    // Check if the filterText is included in any of the search context
    const matchesFilter = searchContext.includes(filterText.toLowerCase());

    return matchesFilter;
  });
  const handleCustomerChange = (selectedOption) => {
    setSelectedCustomer(selectedOption);
  };
  const formatLocalDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const handleDateRangeChange = (selectedDates) => {
    if (selectedDates.length === 2) {
      const [start, end] = selectedDates;
      const startStr = formatLocalDate(start);
      const endStr = formatLocalDate(end);

      const newFilters = { startDate: startStr, endDate: endStr };
      setFilters(newFilters);

      fetchCreditLogs(selectedCustomer?.id, startStr, endStr);
    }
  };
  return (
    <div className="page-content">
      <div className="container-fluid">
        <BreadCrumb
          title="Customer payment collection"
          pageTitle="Reports"
          // breadcrumbItems={breadcrumbItems}
        />
      </div>
      <Row className="mb-2">
        <Col xs={12} md={6}>
          <Select
            options={customerList}
            value={selectedCustomer}
            onChange={handleCustomerChange}
            placeholder="Select customer"
            isClearable
            menuPortalTarget={document.body}
            styles={{
              menuPortal: (base) => ({ ...base, zIndex: 9999 }),
            }}
          />
        </Col>
        <Col md={6}>
          <InputGroup>
            <Flatpickr
              className="form-control form-control-md"
              placeholder="Select Date or Range"
              value={[filters.startDate, filters.endDate]}
              onChange={handleDateRangeChange}
              options={{
                mode: "range",
                dateFormat: "Y-m-d",
                maxDate: "today",
                defaultDate: [oneMonthAgoStr, todayStr],
                allowInput: false,
              }}
            />
            <InputGroupText style={{ cursor: "pointer" }}>
              <i className="bx bx-calendar"></i>
            </InputGroupText>
          </InputGroup>
        </Col>
      </Row>
      <Card>
        <CardBody>
          <Row>
            {selectedCustomer && (
              <div className="d-flex justify-content-between align-content-center align-items-center">
                {filteredData.length > 0 && (
                  <h5>
                    Balanced Amount:{" "}
                    <strong>
                      {" "}
                      <NumberWithCommas
                        number={filteredData[0].remainingAmount}
                      />
                    </strong>
                  </h5>
                )}
                <div className="d-flex justify-content-end mb-3">
                  <button
                    className="btn  btn-success"
                    onClick={() => toggleModal()}
                  >
                    Credit Payment
                  </button>
                </div>
              </div>
            )}
            <div className="table-responsive">
              <Table bordered hover className="mb-0 table-nowrap ">
                <thead className="bg-light">
                  <tr>
                    <th style={{ width: "60px" }}>S.N</th>
                    <th>Reference No</th>
                    <th style={{ width: "20vw" }}>Remarks</th>
                    <th className="text-end">Debit</th>
                    <th className="text-end">Credit</th>
                    <th className="text-end">Balanced Amt</th>
                    <th style={{ width: "9vw" }}>Created By</th>
                  </tr>
                </thead>
                <tbody>
                  {loading ? (
                    <tr>
                      <td colSpan="7" className="text-center py-3">
                        Loading...
                      </td>
                    </tr>
                  ) : filteredData.length > 0 ? (
                    filteredData.map((item, index) => (
                      <tr key={item.id || index}>
                        <td className="fs-6">{index + 1}</td>
                        <td className="fs-6 d-flex flex-column">
                          {item.orderRefrenceId?.startsWith("ORD") ? (
                            <Link to={`/order/${item?.orderRefrenceId}`}>
                              {item.orderRefrenceId}
                            </Link>
                          ) : (
                            <span>{item.orderRefrenceId}</span>
                          )}
                          {formatDateTimes(item.createdDate)}
                        </td>
                        <td
                          className="fs-6"
                          style={{
                            overflow: "hidden",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {item.remarks}
                        </td>
                        <td className="text-end fs-6 text-success">
                          {item.paidAmount > 0 ? (
                            <NumberWithCommas number={item.paidAmount} />
                          ) : (
                            "-"
                          )}
                        </td>
                        <td className="text-end fs-6 text-danger">
                          {item.creditAmount > 0 ? (
                            <NumberWithCommas number={item.creditAmount} />
                          ) : (
                            "-"
                          )}
                        </td>
                        <td className="text-end fs-6 fw-bold">
                          {item.remainingAmount !== null &&
                          item.remainingAmount !== undefined &&
                          item.remainingAmount !== 0 ? (
                            <NumberWithCommas number={item.remainingAmount} />
                          ) : (
                            "-"
                          )}
                        </td>
                        <td className="fs-6" title={item.createdBy}>
                          {item.createdBy?.length > 10
                            ? item.createdBy.substring(0, 10) + "..."
                            : item.createdBy}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="7" className="text-center">
                        No records found for the selected filters.
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </div>
          </Row>
        </CardBody>
      </Card>

      {/* <Card>
        <CardBody>
          <CustomDataTable
            responsive
            striped
            pagination
            fixedHeader
            persistTableHead
            progressPending={loading}
            customStyles={customStyles}
            progressComponent={
              <div className="my-3">
                <Triangle
                  visible={true}
                  height="80"
                  width="80"
                  color="#5B71B9"
                  ariaLabel="triangle-loading"
                />
                <h5 className="mt-1">Loading...</h5>
              </div>
            }
            columns={columns}
            data={filteredData}
          />
        </CardBody>
      </Card> */}
      <CreditPayModal
        isOpen={isOpen}
        toggle={toggleModal}
        fetchCreditLogs={fetchCreditLogs}
        selectedItem={selectedItem}
        selectedCustomer={selectedCustomer}
      />
    </div>
  );
};

export default CustomerPayment;
